module.exports = __webpack_public_path__ + "static/media/storyA_background.2b205804.png";


//////////////////
// WEBPACK FOOTER
// ./src/storyA/static/storyA_background.png
// module id = 310
// module chunks = 0